import React, { useEffect } from "react"
import parse from "html-react-parser"
import ImageShow from "../ImageShow/showImage"
import Aos from "aos"
import "aos/dist/aos.css"
import ScrollButton from "../buttons/scrollButton/scrollButton"
import * as style from "./webinarseat.module.css"

const CallSection = ({ handleClick, joinWebinarQuote, comingSoonWebinar }) => {
  useEffect(() => {
    Aos.init({
      once: true,
    })
  }, [])

  return (
    <section className={style.callSection}>
      <div className="container">
        <div className={style.callSectionWrap}>
          <span data-aos="fade-up" data-aos-delay="50">
            <ImageShow
              imgTagClass={style.quoteImage}
              imageData={"/images/quote-white.svg"}
              alt="quote"
            />
            {parse(`${joinWebinarQuote} `)}
          </span>
          {comingSoonWebinar == "yes" && (
            <ScrollButton
              onClick={() => handleClick(1)}
              btnText="Save my seat"
              data-aos="fade-up"
              data-aos-delay="100"
              customClass='w-auto-imp'
            />
          )}
        </div>
      </div>
    </section>
  )
}

export default CallSection
